<template>
    <div :class="wrapperClass">
        <h3>{{title}}</h3>
        <span class="gauge-current-value">{{currentValue}}{{innerGaugeValueType}}</span>
        <span class="gauge-current-value-type">{{innerGaugeValueIndicator}}</span>

        <GaugeChart
                class="chart"
                :width="250"
                :height="250"
                :chartData='gaugeData'
                :chartOptions="{responsive:true}"
        >

        </GaugeChart>
        <span class="gauge-sub-title">{{subGaugeText}}</span>
    </div>
</template>


<script>
    import GaugeChart from './GaugeChart'

    export default {
        name: 'counter',
        components: {
            GaugeChart
        },
        props: {
            title: {
                type: String,
                default: null
            },
            currentValue: {
                type: Number,
                default: 0,
            },
            normValue: {
                type: Number,
                default: 0,
            },
            innerGaugeValue: {
                type: Number,
                default: 0
            },
            innerGaugeValueIndicator: {
                type: String,
                default: ''
            },
            innerGaugeValueType: {
                type: String,
                default: null
            },
            subGaugeText: {
                type: String,
                default: ''
            },
            wrapperClass: {
                type: String,
                default: ''
            },
            gaugeClassSuccessColor: {
                type: String,
                default: 'green'
            },
            gaugeClassWarningColor: {
                type: String,
                default: 'orange'
            },
            gaugeClassFailColor: {
                type: String,
                default: 'red'
            },
            gaugeData: {
                type: Object,
            }
        },
        data() {
            return {}
        },
        computed: {},
        created() {

        }
    }
</script>
<style lang="scss" scoped>

</style>